import { get } from 'common';

const NEWS_ROUTE = `${process.env.REACT_APP_API_CONFIG}news`;

export class NewsService {
    private static instance: NewsService;

    static getInstance(): NewsService {
        if (!this.instance) {
            this.instance = new NewsService();
        }

        return this.instance;
    }

    async findAll() {
        return await get(`${NEWS_ROUTE}/`);
    }

    async findOne(id: number) {
        return await get(`${NEWS_ROUTE}/${id}`);
    }
}
